module.exports = __webpack_public_path__ + "cdb0c4f430cfe6f46c53b230fa4bedee.vtt";